import { Result, Tenant } from "@models";
import requests from "./agent";

export const favoriteService = {
  getAll: async () => {
    const response = await requests.get<Result<{ items: Tenant[] }>>(
      "/api/Tenant/GetFavorites"
    );
    return response.result.items;
  },

  toggle: async (tenantId: number) => {
    const response = await requests.post<Result<boolean>>(
      "/api/Tenant/ToggleFavorite",
      { tenantId }
    );
    return response.result;
  },
};
